import {Identifier, makeNumericId} from "../common/Identifier";
import {SoftDeletable} from "../common/SoftDeletable";
import {ACCOUNTING_AREA_TYPE_NAME, CanceledBillLinkable, ContractorBillable} from "./AccountBook";
import {Module} from "../common/Module";
import {Nullable} from "../common/Nullable";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {isPrivileged, isPrivilegedByIdentifier, Privileges} from "../../config/Privileges";
import {IncomingInvoiceProjectStage} from "./IncomingInvoiceProjectStage";
import {InvoiceType} from "./InvoiceType";
import {makeSensitive} from "../common/Sensitive";
import {InvoiceMode} from "./InvoiceMode";


export const IncomingInvoiceModule: Module = {
    identifier: 'incoming_invoice',
    isPrivileged: (authUser: Nullable<AuthenticatedUser>, privilege: string, privilegeIdentifier?: string) => {

        if (typeof privilegeIdentifier !== "undefined") {
            return isPrivilegedByIdentifier(authUser, privilegeIdentifier);
        } else {
            return isPrivileged(
                authUser,
                ACCOUNTING_AREA_TYPE_NAME,
                IncomingInvoiceModule.identifier,
                privilege
            );
        }
    }
};


export const IncomingInvoicePrivileges = {
    ...Privileges,
    markFinal: "MARK_DONE",
    markCanceled: "MARK_CANCELED"
};

export interface IncomingInvoiceId {
    invoiceId: Identifier<number>
}

export interface IncomingInvoice extends IncomingInvoiceId,SoftDeletable, ContractorBillable< IncomingInvoiceId >, CanceledBillLinkable {
    stages: IncomingInvoiceProjectStage[]
    arNumber: string

}

export type IncomingInvoiceProp = {
    incomingInvoice: IncomingInvoice
}

export function defaultIncomingInvoice(): IncomingInvoice {
    return {
        type: InvoiceType.PARTIAL_INVOICE,
        mode: InvoiceMode.IN_PROCESS,
        totals: {
            amountOwed: makeSensitive( 0.0 ),
            approvedAmountOwed: makeSensitive( 0.0 ),
            approvedAmountOwedWithTax: makeSensitive( 0.0 ),
            amountOwedWithTax: makeSensitive( 0.0 ),
            salesTaxByTax: {},
            finalAmountOwed: makeSensitive( 0.0 ),
            totalPayments: makeSensitive( 0.0 ),
            totalSalesTaxAmount: makeSensitive( 0.0 ),
            openAmountOwed: makeSensitive( 0.0 )
        },
        payableState: {
            payments: [],
            prePayment: makeSensitive( 0 ),
            paymentExpected: new Date(),
            paymentExpectedInDays: 0,
            bankingInfo: null
        },
        invoiceNumber: "",
        stages: [],
        items: [],
        isDeleted: false,
        invoiceId: makeNumericId( 0 ),
        year: ( new Date() ).getFullYear(),
        invoiceDate: new Date(),
        period: {
            startAt: new Date(),
            finishAt: new Date()
        },
        project: {
            projectId: makeNumericId( 0 ),
            shortDescription: "",
            projectNumber: ""
        },
        contractor: {
            contractorId: makeNumericId( 0 ),
            name: "",
            isDeleted: false
        },
        arNumber: "",
        canceledBill: null
    };
}